import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { FINANCIALANALYSYS_LIST_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class GetFinancialAnalysisList extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = [];

  url = FINANCIALANALYSYS_LIST_URL;

  constructor(applicantId) {
    super();
    const paramList = [applicantId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
